module.exports = __webpack_public_path__ + "img/preview-right.b8c21364.png";